export default Object.freeze([
  'Адвокат',
  'Юрист',
  'Психолог',
  'Детский психолог',
  'Психотерапевт',
  'Общественная защита',
  'ТСД',
])
